// one seam for page navigation, so tests can assert where an action goes (jsdom can't replace location)
export const navigate = url => window.location.assign(url)
